import { get, patch, post } from 'api/requests';
import { urlBooking, urlBookings, urlBookingStop, urlCancelationReasons, urlDeliveryRouteByBooking, urlDeliveryRouteChatsByBooking } from 'api';
import { message } from '../commons/actions';
import handleErrorMessage from 'utils/handleErrorMessage';
import {
  LIST_BOOKING,
  LIST_EVENTS,
  GET_AMOUNT_LEFT_TO_COLLECT_BY_COMPANY,
  LIST_DELIVERY_ROUTE,
  LIST_DELIVERY_ROUTE_CHATS
} from './constants';
import { COUNTRY_CODE } from 'utils/constants';
import { formatPrice } from 'utils';

export const listBooking = async (dispatch, id, company_id = {}) => {
  let loadingBooking = true;
  await get(`${urlBooking}/${id}`, company_id)
    .then(({ data }) => {
      dispatch({
        type: LIST_BOOKING,
        list: data,
      });
      loadingBooking = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingBooking = false;
    });
  return { loadingBooking };
};

export const listDeliveryRoute = async (dispatch, bookingId, company_id = {}) => {
  let loadingRoute = true;
  await get(urlDeliveryRouteByBooking(bookingId), company_id)
    .then(({ data }) => {
      dispatch({
        type: LIST_DELIVERY_ROUTE,
        deliveryRoute: data,
      });
      loadingRoute = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingRoute = false;
    });
  return { loadingRoute };
};

// One thread per prepackage, scoped to what the session may see (specs/007-chat-por-paquete/).
// Feeds DeliveryRouteChatList; the actual chat socket is opened only for the selected thread.
export const listDeliveryRouteChats = async (dispatch, bookingId) => {
  let loadingDeliveryRouteChats = true;
  await get(urlDeliveryRouteChatsByBooking(bookingId))
    .then(({ data }) => {
      dispatch({
        type: LIST_DELIVERY_ROUTE_CHATS,
        deliveryRouteChats: data,
      });
      loadingDeliveryRouteChats = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingDeliveryRouteChats = false;
    });
  return { loadingDeliveryRouteChats };
};

export const cancelBookingAction = async (id, token, dispatch, reason = {}) => {
  let loadingCancel = true;
  const payload = { t: token };
  if (reason.cancelation_reason_cd) {
    payload.cancelation_reason_cd = reason.cancelation_reason_cd;
  }
  if (reason.other_cancelation_reason) {
    payload.other_cancelation_reason = reason.other_cancelation_reason;
  }
  await patch(`${urlBooking}/${id}/cancel`, payload)
    .then(() => {
      window.location.reload();
      loadingCancel = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingCancel = false;
    });
  return { loadingCancel };
};

export const getCancelationReasonsAction = async (dispatch) => {
  let reasons = [];
  await get(urlCancelationReasons, {})
    .then(({ data }) => {
      reasons = Array.isArray(data) ? data : [];
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
    });
  return reasons;
};

export const relaunchedBookingAction = async (id, dispatch, token) => {
  let loadingRelaunched = true;
  await post(`${urlBooking}/${id}/relaunch`, { t: token })
    .then((json) => {
      return json.data;
    })
    .then((currentBooking) => {
      loadingRelaunched = false;
      if (currentBooking.relaunched_to && currentBooking.relaunched_to._id) {
        window.location.href = `/bookings/${currentBooking.relaunched_to._id}`;
      } else {
        alert('Oops, un servicio no puede ser relanzado más de 3 veces.');
      }
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingRelaunched = false;
    });
  return { loadingRelaunched };
};

export const getTripEvents = async (id, dispatch) => {
  let loading = true;
  await get(`${urlBooking}/${id}/events`, {})
    .then(({ data }) => {
      dispatch({
        type: LIST_EVENTS,
        events: data,
      });
      loading = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loading = false;
    });
  return { loading };
};

export const confirmCollection = async (dispatch, id, amount) => {
  let status = false;
  await post(`${urlBookings}/${id}/collect_counter_delivery`, amount)
    .then((json) => {
      return json.data;
    })
    .then(() => {
      status = true;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      status = false;
    });
  return { status };
};

export const getPendingCollection = async (dispatch, id) => {
  let loading = true;
  await get(`${urlBookings}/${id}/amount_left_to_collect_by_company`)
    .then(({ data }) => {
      dispatch({
        type: GET_AMOUNT_LEFT_TO_COLLECT_BY_COMPANY,
        amountLeftToCollectByCompany: data,
      });
      loading = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loading = false;
    });
  return { loading };
};

export const addStop = async (dispatch, id, values, lang) => {
  let status = false;

  const booking_stop = {
    address: values?.address?.name,
    lat: values?.address?.lat,
    lon: values?.address?.lon,
    customer: {
      name: values?.name || '',
      country_code: values?.phone ? values.country_code : '',
      phone: values?.phone || '',
      email: values?.email || ''
    },
    packages: [
      {
        indications: values?.indications || '',
        reference: values?.reference || '',
        size_cd: values?.size_cd ? parseInt(values.size_cd) : 0,
        declared_value: {
          sub_units: formatPrice({
            sub_units: values?.declared_value,
            iso: COUNTRY_CODE[lang][4],
          }),
          currency: COUNTRY_CODE[lang][4]
        },
        counter_delivery: values.counter_delivery,
        hand_to_hand_delivery: values.hand_to_hand_delivery || false,
        collected_value: values.counter_delivery ? {
          sub_units: formatPrice({
            sub_units: values?.collected_value,
            iso: COUNTRY_CODE[lang][4],
          }),
          currency: COUNTRY_CODE[lang][4]
        } : null
      }
    ]
  }

  await post(`${urlBooking}/${id}/add_stop`, {booking_stop})
    .then((json) => {
      return json.data;
    })
    .then(() => {
      status = true;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      status = false;
    });
  return { status };
};

export const returnToOriginAction = async (id, token, dispatch) => {
  let loadingReturnToOrigin = true;
  let info = null;
  await get(`${urlBooking}/${id}/return_to_origin_price_difference`, { t: token })
    .then(({ data }) => {
      loadingReturnToOrigin = false;
      info = data
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingReturnToOrigin = false;
      info = null
    });
  return { loadingReturnToOrigin, info };
};

export const confirmReturnToOriginAction = async (bookingId, token, dispatch) => {
  let loadingConfirmReturn = true;
  await patch(`${urlBooking}/${bookingId}/add_return_to_origin`, { t: token })
    .then(() => {
      window.location.reload();
      loadingConfirmReturn = false;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      loadingConfirmReturn = false;
    });
  return { loadingConfirmReturn };
};


export const editAddress = async (dispatch, id, values, isOrigin) => {
  let status = false;
  const addressData = {
    address: values?.address?.name,
    lat: values?.address?.lat,
    lon: values?.address?.lon,
    secondary_address: values?.secondary_address || ""
  }

  const url = isOrigin ? `${urlBooking}/${id}/set_origin_address_by_passenger` : `${urlBookingStop}/${id}/set_address_by_passenger`
  const payload = isOrigin ? { booking: addressData } : { booking_stop: addressData }

  await patch(url, payload)
    .then((json) => {
      return json.data;
    })
    .then(() => {
      status = true;
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      status = false;
    });
  return { status };
};
